// Roles
export const PROJECT_ROLES = ['owner', 'editor', 'viewer']
export const CRITICALITY_LEVELS = ['critical', 'important', 'info']
export const FULFILLMENT_VALUES = ['yes', 'no', 'partial', 'unclear', 'na', 'ungraded']
export const MESSAGE_ROLES = ['user', 'assistant', 'system']
export const UPLOAD_FORMATS = ['csv', 'json', 'openai']
export const TASK_TYPES = ['tagging', 'evaluation', 'review']
export const TASK_STATUSES = ['open', 'closed']
export const DETAIL_TYPES = ['enum', 'range', 'boolean']

// Built-in highlight types
export const BUILTIN_HIGHLIGHTS = [
  { id: 'hl-hallucination', name: 'Hallucination', color: '#ff6b6b' },
  { id: 'hl-safety', name: 'Safety', color: '#ffa94d' },
  { id: 'hl-pii', name: 'PII', color: '#a9e34b' },
  { id: 'hl-comment', name: 'Comment', color: '#74c0fc' },
]

export const FORM_OPTIONS = ['email', 'chat', 'phone_transcript', 'intake_form', 'letter', 'forum_post']
export const TONE_OPTIONS = ['confused', 'angry', 'matter_of_fact', 'verbose', 'terse', 'confident_wrong', 'anxious', 'formal', 'casual']
export const INCLUSION_FREQUENCIES = ['always', 'often', 'sometimes', 'rarely', 'never']
export const INCLUSION_PROBABILITIES = { always: 1.0, often: 0.75, sometimes: 0.5, rarely: 0.25, never: 0 }
